import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { FlagComponent } from './flag.component';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild()
  ],
  declarations: [
    FlagComponent
  ],
  exports: [
    FlagComponent
  ]
})

export class FlagModule {}
